import React, { useCallback } from 'react'
import styled from 'styled-components'
import { useHistory, useLocation } from 'react-router-dom'

import Flex from 'components/reusable/flex'
import Text from 'components/reusable/text'
import Button from 'components/reusable/button'
import ModalCloseButton from 'components/modals/v2/modal_close_button'
import ModalStandardWrapper from 'components/modals/v2/modal_standard_wrapper'
import { colors } from 'helpers/colors'
import { routes } from 'helpers/router_helper'
import SvgWalletSolid from 'components/reusable/svg/svg_wallet_solid'
import ApplicationHelper from 'helpers/application_helper'
import ModalCloseButtonV2 from '../modal_close_button_v2'

const IconWrapper = styled(Flex)`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: ${colors.primary[50]};
`

const ButtonsWrapper = styled(Flex)`
  width: 100%;
  margin-top: 8px;
`

function ConnectBankAccountModal({ onClose }) {
  const history = useHistory()
  const location = useLocation()
  const paymentSettingsPath = routes.paymentSettings.redirectUrl()
  const isMobile = ApplicationHelper.isMobile

  const handleAddBankAccount = useCallback(() => {
    onClose()
    if (location.pathname !== paymentSettingsPath) {
      history.push(paymentSettingsPath)
    }
  }, [onClose, history, location.pathname, paymentSettingsPath])

  const handleClose = useCallback(() => {
    onClose()
    const referralsPath = routes.referrals.redirectUrl()
    if (location.pathname !== referralsPath) {
      history.push(referralsPath)
    }
  }, [onClose, history, location.pathname])

  return (
    <ModalStandardWrapper $minWidth={400}>
      <ModalCloseButtonV2 onClose={onClose} />

      <Flex dir="column" ai="center" gap={24} width="100%">
        <IconWrapper ai="center" jc="center">
          <SvgWalletSolid color={colors.primary[500]} />
        </IconWrapper>

        <Flex dir="column" ai="center" gap={12}>
          <Text size={24} weight={500} textAlign="center">
            Connect your bank account
          </Text>
          <Text textAlign="center">
            You don't have a bank account connected yet.{isMobile ? <br /> : '&nbsp;'}
            Please add one to receive your referral rewards.
          </Text>
        </Flex>

        <ButtonsWrapper dir="column" gap={12}>
          <Button
            type="primary"
            width="100%"
            height={40}
            onClick={handleAddBankAccount}
          >
            <Text size={16} weight={500} color={colors.light}>
              Add Bank Account
            </Text>
          </Button>

          <Button
            type="secondary"
            width="100%"
            height={40}
            onClick={handleClose}
          >
            <Text size={16} weight={500}>
              Maybe Later
            </Text>
          </Button>
        </ButtonsWrapper>
      </Flex>
    </ModalStandardWrapper>
  )
}

export default ConnectBankAccountModal
